/*** Copyright 2026 Parts Pioneer Inc. ***/

function getFitmentFields() {
  let output = [
    "year",
    "make",
    "model",
    "trim",
    "notes",
    "engine",
    "drive_type",
    "body_type",
    "body_doors",
    "transmission",
    "cylinders",
    "cylinder_head",
    "fuel_type",
    "aspiration",
    "transmission_speeds",
    "brake_system",
    "front_spring",
    "rear_spring",
    "steering",
    "front_brake",
    "rear_brake",
    "horsepower",
    "mfr_label",
    "position"
  ];
  return output;
}

function getFitmentFieldname(field) {
  let fieldnames = {
    "year": "Year",
    "make": "Make",
    "model": "Model",
    "trim": "Trim",
    "notes": "Notes",
    "engine": "Engine",
    "drive_type": "Drive Type",
    "body_type": "Body Type",
    "body_doors": "Body Doors",
    "transmission": "Transmission",
    "cylinders": "Cylinders",
    "cylinder_head": "Cylinder Head",
    "fuel_type": "Fuel Type",
    "aspiration": "Aspiration",
    "transmission_speeds": "Transmission Speeds",
    "brake_system": "Brake System",
    "front_spring": "Front Spring",
    "rear_spring": "Rear Spring",
    "steering": "Steering",
    "front_brake": "Front Brake",
    "rear_brake": "Rear Brake",
    "horsepower": "Horsepower",
    "mfr_label": "Label",
    "position": "Position on Vehicle"
  }
  return fieldnames[field];
}

class FitmentCheck {

  constructor() {
    this.vehicle = {
      "year": "",
      "make": "",
      "model": ""
    };
    this.has_selected_vehicle = false;
    this.setYmm();
    this.checkProducts();
  }

  setYmm() {
    if (localStorage.getItem("ymm") !== null) {
      let selected_ymm = JSON.parse(localStorage.getItem("ymm"));
      if (selected_ymm.year !== "" && selected_ymm.make !== "" && selected_ymm.model !== "") {
        this.vehicle.year = selected_ymm.year;
        this.vehicle.make = selected_ymm.make;
        this.vehicle.model = selected_ymm.model;
        this.has_selected_vehicle = true;
      } else {
        this.vehicle.year = "";
        this.vehicle.make = "";
        this.vehicle.model = "";
        this.has_selected_vehicle = false;
      }
    } else {
      this.vehicle.year = "";
      this.vehicle.make = "";
      this.vehicle.model = "";
      this.has_selected_vehicle = false;
    }
  }


  getSvg(fits) {
    let output = ''
    if (this.has_selected_vehicle === true) {
      if (fits === true) {
        output = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M20.5303 7.53033C20.8232 7.23744 20.8232 6.76256 20.5303 6.46967C20.2374 6.17678 19.7626 6.17678 19.4697 6.46967L20.5303 7.53033ZM9.00004 18L8.46972 18.5303C8.76261 18.8232 9.23748 18.8232 9.53037 18.5303L9.00004 18ZM4.53026 12.4697C4.23736 12.1768 3.76249 12.1768 3.4696 12.4697C3.17671 12.7626 3.17672 13.2374 3.46962 13.5303L4.53026 12.4697ZM19.4697 6.46967L8.46971 17.4696L9.53037 18.5303L20.5303 7.53033L19.4697 6.46967ZM3.46962 13.5303L8.46972 18.5303L9.53036 17.4696L4.53026 12.4697L3.46962 13.5303Z"/>' +
          '</svg>';
      } else {
        output = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L19.5303 5.53033ZM4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L4.46967 18.4697ZM5.53034 4.46967C5.23745 4.17678 4.76258 4.17678 4.46968 4.46967C4.17679 4.76256 4.17679 5.23744 4.46968 5.53033L5.53034 4.46967ZM18.4697 19.5303C18.7626 19.8232 19.2375 19.8232 19.5304 19.5303C19.8232 19.2374 19.8232 18.7626 19.5304 18.4697L18.4697 19.5303ZM18.4697 4.46967L4.46967 18.4697L5.53033 19.5303L19.5303 5.53033L18.4697 4.46967ZM4.46968 5.53033L18.4697 19.5303L19.5304 18.4697L5.53034 4.46967L4.46968 5.53033Z"/>' +
          '</svg>'
      }
    } else {
      output = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M12.75 16.99C12.75 16.5758 12.4142 16.24 12 16.24C11.5858 16.24 11.25 16.5758 11.25 16.99H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14H11.25ZM11.25 16.99V17H12.75V16.99H11.25ZM11.25 7V14H12.75V7H11.25ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75Z"/>' +
        '</svg>';
    }
    return output;
  }

  getOutputVehicle() {
    if (this.has_selected_vehicle === false) {
      return "";
    }

    let year = this.vehicle.year;
    let make = this.vehicle.make;
    let model = this.vehicle.model;
    if (!year || !make || !model) {
      return "";
    }

    return year + " " + make + " " + model;
  }

  setVehicleParam(variant_id, fits_ymm) {
    let vehicle_param = jQuery(".line-item-property__field #vehicle-param-" + variant_id);
    if (this.has_selected_vehicle === true && fits_ymm === true) {
      let output_vehicle = this.getOutputVehicle()
      vehicle_param.val(output_vehicle);
    }
  }

  getCollectionHandle() {

    if (this.has_selected_vehicle === false) {
      return "#";
    }

    let year = this.vehicle.year;
    let make = this.vehicle.make;
    let model = this.vehicle.model;
    if (!year || !make || !model) {
      return "#";
    }

    let output_ymm = year + "-" + make + "-" + model;
    let output = output_ymm.replace(/ /g, "-").toLocaleLowerCase();

    let handle = output_ymm.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
    if (handle !== output) {
      return "#";
    }

    return "/collections/" + output;
  }

  fitmentCheckResultOutput(variant_id, output_svg, output_obj, grid) {

    let fitment_check_div = jQuery("#fitment-check-" + variant_id + ', #fitment-check-compare-' + variant_id);

    fitment_check_div = fitment_check_div.filter(function () { return !this.children.length; });
    if (!fitment_check_div.length) return;
    
    let output_div_class = output_obj["container_class"];
    let output_main_value = output_obj["main_value"];
    let output_details_value = output_obj["details_value"];

 
    let output_div = jQuery("<div>", { class: "fitment-check " + output_div_class })
    let output_icon = jQuery("<div>", { class: "fitment-check-icon" })
    let output_main = jQuery("<div>", { class: "fitment-check-main" })
    let output_details = jQuery("<div>", { class: "fitment-check-details" });

    if (grid === true) {
      output_div.addClass("fitment-check-grid-item")
    }

    output_icon.append(output_svg);
    output_main.append(output_icon);
    output_main.append(output_main_value);
    output_details.append(output_details_value);

    output_div.append(output_main);
    output_div.append(output_details);
    fitment_check_div.append(output_div);
    if (grid === true) addSeeMore(fitment_check_div);

  }

  noYmmResult() {
    let output = {
      "container_class": "fitment-check-no-ymm",
      "main_value": "<span>No vehicle selected.</span>",
      "details_value": '<span><span id="select-ymm">Select a vehicle</span> to check fitment.</span>'
    }
    return output;
  }

  writeFitmentDetails(fitment_details_list) {
    let output = '';
    let fitment_fields = getFitmentFields();
    let count = 0;
    fitment_details_list.forEach(function(details) {
      let output_item = "";
      
      fitment_fields.forEach(function(fitment_field) {
        if (!(fitment_field in details)) {
          return;
        }
        let details_value = details[fitment_field];
        if (fitment_field === "notes") {
            details_value = details_value.join(". ");
        }
        output_item += '<li><strong>' + getFitmentFieldname(fitment_field) + ': </strong><span>' + details_value + '</span></li>';
      });
        
      if (output_item.length > 0) {
        output += '<ul>' + output_item + '</ul>';
        count++;
      }
    });
    
    if (output.length === 0) {
      return '';
    }
    
    let output_class = "fitment-details";
    if (count == 1) {
      output_class += " " + "one-detail";
    }
    
    output = '<div class="' + output_class + '">' + output + '</div>'
    return output;
  }

  fitsYmmResult(fitment_details_list, grid) {
    let output_details = '';
    let fitment_details = this.writeFitmentDetails(fitment_details_list);

    if (fitment_details.length > 0) {
      let details_summary = '<span>Only if these conditions are met:</span>';
      let details_open = "open";
      if (grid === true) {
        details_summary = '<span>Only if:</span>';
        details_open = "open";
      }
      output_details = '<details ' + details_open + '><summary>' + details_summary + '</summary>' + fitment_details + '</details>';
    }

    let output_vehicle = this.getOutputVehicle();
    let collection_handle = this.getCollectionHandle();
    let output = {
      "container_class": "fitment-check-fits",
      "main_value": '<span><span class="guaranteed-fit">Guaranteed to Fit</span> ' + output_vehicle + '</span>',
      "details_value": output_details
    };

    if (!grid) {
      output.details_value += '<div class="also-shop">Also ' + '<a href="' + collection_handle + '">' + 'see other parts' + '</a>' + ' that fit this vehicle.</div>'
    }

    return output;
  }

  doesNotFitResult() {
    let collection_handle = this.getCollectionHandle();
    let output_vehicle = this.getOutputVehicle();
    let output = {
      "container_class": "fitment-check-does-not-fit",
      "main_value": '<span>Does not fit ' + output_vehicle + '.</span>',
      "details_value": '<span><a href="' + collection_handle + '">Click here</a> to shop for ' + output_vehicle + '.</span>'
    };
    return output;
  }
  
  fitmentCheckResult(handle, variant_id, fits_ymm, fitment_details_list, grid) {

    let output_svg = this.getSvg(fits_ymm);
    let output_obj = {
      "container_class": "",
      "main_value": "",
      "details_value": ""
    };

    if (this.has_selected_vehicle === true) {

      if (fits_ymm === true) {
        output_obj = this.fitsYmmResult(fitment_details_list, grid);
      } else {
        output_obj = this.doesNotFitResult();
      }
    } else {
      output_obj = this.noYmmResult();
    }

    this.fitmentCheckResultOutput(variant_id, output_svg, output_obj, grid)
  }

  createAllFitmentButton() {
    let output = '<div id="all-fitment"><span>See other compatible vehicles</span></div>';
    jQuery(output).insertAfter(jQuery("#fitment-table-container"));
  }

  filterFitmentTable(fits_ymm) {
    if (this.has_selected_vehicle === true && fits_ymm === true) {
      let self = this;
      let other_fitment = false
      let fit, fit_year, fit_make, fit_model;
      jQuery("#fitment-table").find("tbody tr").each(function (i, e) {
        fit = jQuery(e);
        fit_year = fit.find(".year").text();
        fit_make = fit.find(".make").text();
        fit_model = fit.find(".model").text();

        if (self.sameVehicle(fit_year, fit_make, fit_model)) {
          fit.css("display", "");
        } else {
          fit.css("display", "none");
          other_fitment = true;
        }
      });

      if (other_fitment) {
        this.createAllFitmentButton();
      }
    }
  }

  getFitmentDetails(product_fit) {
    let output = {}
    let fitment_fields = getFitmentFields();
    fitment_fields.forEach(function(fitment_field) {
      
      if (!(fitment_field in product_fit)) {
        return;
      }
      if (fitment_field === "year" || fitment_field === "make" || fitment_field === "model" || fitment_field === "position") {
        return;
      }
      
      let fitment_value = product_fit[fitment_field];
      if (fitment_value.length === 0 || fitment_value === "All") {
        return;
      }
      output[fitment_field] = fitment_value;
      
    });
    return output;
  }
  
  submitProduct(handle, variant_id, grid) {
    let self = this;
    if (self.has_selected_vehicle === true) {
      jQuery.ajax({
        url: handle,
        data: { "view": "fitment" },
        dataType: "html",
        success: function (res) {
          let product_fitment = JSON.parse(res);
          let product_fits_ymm = false;
          let fitment_details_list = [];

          for (let i = 0; i < product_fitment.fits.length; i++) {
            let product_fit = product_fitment.fits[i];
            if (self.sameVehicle(product_fit.year, product_fit.make, product_fit.model)) {
              product_fits_ymm = true;
              fitment_details_list.push(self.getFitmentDetails(product_fit));
            }
          }
          self.setVehicleParam(variant_id, product_fits_ymm);
          self.fitmentCheckResult(handle, variant_id, product_fits_ymm, fitment_details_list, grid);
          if (grid === false) {
            self.filterFitmentTable(product_fits_ymm);
          }
          fitmentCheck.fitmentResults = fitmentCheck.fitmentResults || {};
          fitmentCheck.fitmentResults[variant_id] = product_fits_ymm;
        }
      })
    }
    else {
      if (grid === false) {
        self.fitmentCheckResult(handle, variant_id, false, [], grid);
      }
    }
  }

  sameVehicle(input_year, input_make, input_model) {
    if (this.vehicle.year === input_year || parseInt(this.vehicle.year) === parseInt(input_year)) {
      if (this.vehicle.make.toLowerCase() === input_make.toLowerCase()) {
        if (this.vehicle.model.toLowerCase() === input_model.toLowerCase()) {
          return true;
        }
        if (this.vehicle.model.toLowerCase().replace(" ", "-") === "f-super-duty" && input_model.toLowerCase().replace(" ", "-") === "f-super-duty") return true;
      }
      
    }
    return false;
  }

  checkProducts() {
    let self = this;
    jQuery('[id^="fitment-check-product-info-"]').each(function() {
      if (jQuery(this).attr("data-check-item") !== "fitment-check-module") return;
      let product_info = JSON.parse(this.text);
      if (product_info.hasOwnProperty("product_handle") && product_info.hasOwnProperty("variant_id") && product_info.hasOwnProperty("grid")) {
        self.submitProduct(product_info.product_handle, product_info.variant_id, product_info.grid);
      }
    });
  }
}

function removeFitmentTableFilter() {
  jQuery("#fitment-table").find("tbody tr").each(function (i, e) {
    jQuery(e).css("display", "");
  });
}

jQuery(document).on("click", "#all-fitment", function () {
  removeFitmentTableFilter();
  jQuery("#all-fitment").empty();
});

// jQuery(document).on("click", "#open-fitment-table", function () {
//   jQuery("#fitment-table").get(0).scrollIntoView();
// });

jQuery(document).on("click", "#select-ymm", function () {
  openYmm();
});

// let fitmentCheck = new FitmentCheck();
window.fitmentCheck = new FitmentCheck();
     
const collectionFiltersAppliedUnsubscribeHandler = subscribe(PUB_SUB_EVENTS.collectionFiltersApplied, (data) => {
  fitmentCheck.checkProducts();
});

const compareModalLoadUnsubscribeHandler = subscribe(PUB_SUB_EVENTS.compareModalLoad, (data) => {
  fitmentCheck.checkProducts();
});


function addSeeMore(root){
  const lim = innerHeight * 0.25;
  jQuery(root).find(".fitment-details").each(function () {
    const el = this;
    if (el.scrollHeight <= lim || el.dataset.seeMore) return;
    el.dataset.seeMore = "1";

    jQuery('<button type="button" class="fitment-see-toggle">See more</button>').insertAfter(el);
    const btn = el.nextSibling;

    const set = c => (
      el.style.maxHeight = c ? "25vh" : "",
      el.style.overflow  = c ? "hidden" : "",
      btn.textContent    = c ? "See more" : "See less"
    );

    set(true);
    btn.onclick = () => set(btn.textContent === "See less");
  });
}
